<div class="account-section">
  <div class="my-section-box">

    <div class="my-section-box__headline">{{'dataExtractionRquest.reportECURecipient'|cxTranslate}}
    </div>
    <div class="data-extraction__form">
      <div class="my-section-box-inner">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <label class="checkbox">
              <input type="checkbox" [(ngModel)]="sameAsAbove"
                (change)="setupFormValuesOnCheckboxClick($event)">
                <span class="margin-left-35">{{'reportECURecipientForm.checkbox_label'|cxTranslate}}</span>
              </label>
            </div>
          </div>
          <form [formGroup]="reportECURecipientForm">
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <label for="companyName"
                class="control-label">{{'reportECURecipientForm.companyName'|cxTranslate}}</label>
                <div class="input-wrapper-with-icon">
                  <div class="input-with-icon">
                    <input class="form-control" formControlName="companyName" name="companyName"
                                        [ngClass]="{ 'is-valid':(reportECURecipientForm?.get('companyName')?.dirty  ) && !reportECURecipientForm?.get('companyName')?.errors, 
                                                                'is-invalid': (reportECURecipientForm?.get('companyName')?.dirty  ) && reportECURecipientForm?.get('companyName')?.errors }" />

                      <img class="info-icon" src="icons/question_dark_kb.svg" alt="Info"
                        (click)="openPopupCompanyName()" />
                      </div>
                      @if (
                        reportECURecipientForm.get('companyName')?.invalid &&
                        (reportECURecipientForm.get('companyName')?.dirty ||
                        reportECURecipientForm.get('companyName')?.touched
                        )
                        ) {
                        <div class="invalid-feedback-icon">
                          {{'dataExtractionRquest.error_message'|cxTranslate}}
                        </div>
                      }
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <label for="contactName"
                    class="control-label">{{'reportECURecipientForm.contactName'|cxTranslate}}</label>
                    <div class="input-wrapper-with-icon">
                      <div class="input-with-icon">
                        <input class="form-control" formControlName="contactName" name="contactName"
                                        [ngClass]="{ 'is-valid': (reportECURecipientForm?.get('contactName').dirty  ) && !reportECURecipientForm?.get('contactName')?.errors, 
                                                                                                            'is-invalid': (reportECURecipientForm?.get('contactName').dirty  ) && reportECURecipientForm?.get('contactName')?.errors }">
                          <img src="/icons/question_dark_kb.svg" class="info-icon" alt="Back"
                            (click)="openPopupContactName()">
                          </div>
                          @if (
                            reportECURecipientForm.get('contactName')?.invalid &&
                            (reportECURecipientForm.get('contactName')?.dirty ||
                            reportECURecipientForm.get('contactName')?.touched
                            )
                            ) {
                            <div class="invalid-feedback-icon">
                              {{'dataExtractionRquest.error_message'|cxTranslate}}
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <label for="email"
                        class="control-label">{{'reportECURecipientForm.contactEmail'|cxTranslate}}</label>
                        <input type="email" class="form-control" formControlName="contactEmail"
                                [ngClass]="{ 'is-valid':(reportECURecipientForm?.get('contactEmail')?.dirty  ) && !reportECURecipientForm?.get('contactEmail')?.errors, 
                                                        'is-invalid': (reportECURecipientForm?.get('contactEmail').dirty  ) && reportECURecipientForm?.get('contactEmail')?.errors }" />
                          <div class="invalid-feedback">
                            @if ( reportECURecipientForm?.get('contactEmail')?.errors && reportECURecipientForm?.get('contactEmail')?.errors['required']) {
                              <span class="text-danger-show"
                              >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                            }
                            @if ( reportECURecipientForm?.get('contactEmail')?.errors && reportECURecipientForm?.get('contactEmail')?.errors['contactEmail']) {
                              <span class="text-danger-show"
                              >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                            }
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                          <label for="contactPhone"
                          class="control-label">{{'reportECURecipientForm.contactPhoneNumber'|cxTranslate}}</label>
                          <input type="text" formControlName="contactPhone" class="form-control" name="contactPhone"
                                [ngClass]="{ 'is-valid': (reportECURecipientForm?.get('contactPhone').dirty  ) && !reportECURecipientForm?.get('contactPhone')?.errors, 
                                                                            'is-invalid': (reportECURecipientForm?.get('contactPhone').dirty  ) && reportECURecipientForm?.get('contactPhone')?.errors }">
                            <div class="invalid-feedback">
                              @if ( reportECURecipientForm?.get('contactPhone')?.errors && reportECURecipientForm?.get('contactPhone')?.errors['required']) {
                                <span class="text-danger-show"
                                >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                              }
                            </div>
                          </div>
                        </div>

                        <div class="row margin-top-25">
                          <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="companyName"
                            class="control-label">{{'reportECURecipientForm.companyAddresswithStreetNumber'|cxTranslate}}</label>
                            <input type="text" formControlName="address1" class="form-control" name="companyName"
                              [ngClass]="{ 'is-valid': (reportECURecipientForm?.get('address1')?.dirty  ) && !reportECURecipientForm?.get('address1')?.errors, 'is-invalid': (reportECURecipientForm?.get('address1')?.dirty  ) && reportECURecipientForm?.get('address1')?.errors }">
                              <div class="invalid-feedback">
                                @if ( reportECURecipientForm?.get('address1')?.errors && reportECURecipientForm?.get('address1')?.errors['required']) {
                                  <span class="text-danger-show"
                                  >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                }
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <label for="address2"
                              class="control-label">{{'reportECURecipientForm.address2'|cxTranslate}}</label>
                              <input type="text" formControlName="address2" class="form-control" name="address2">
                            </div>
                          </div>

                          <div class="row margin-top-25">
                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                              <label for="city"
                              class="control-label">{{'reportECURecipientForm.city'|cxTranslate}}</label>
                              <input type="text" formControlName="city" class="form-control" name="city"
                                [ngClass]="{ 'is-valid': (reportECURecipientForm?.get('city')?.dirty  ) && !reportECURecipientForm?.get('city')?.errors, 'is-invalid': (reportECURecipientForm?.get('city')?.dirty  ) && reportECURecipientForm?.get('city')?.errors }">
                                <div class="invalid-feedback">
                                  @if ( reportECURecipientForm?.get('city')?.errors && reportECURecipientForm?.get('city')?.errors['required']) {
                                    <span class="text-danger-show"
                                    >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                  }
                                </div>
                              </div>
                              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <label for="state"
                                class="control-label">{{'reportECURecipientForm.state'|cxTranslate}}</label>
                                <div class="select-box">
                                  <select name="state" class="form-control" formControlName="state"
                                    [ngClass]="{ 'is-valid': (reportECURecipientForm?.get('state').dirty  ) && !reportECURecipientForm?.get('state')?.errors, 'is-invalid': (reportECURecipientForm?.get('state').dirty  ) && reportECURecipientForm?.get('state')?.errors }">
                                    <option [ngValue]="null" disabled selected>
                                    {{'common.register_state_placeholder'|cxTranslate}}</option>
                                    @for (item of stateList?.regionsWSList; track item) {
                                      <option [ngValue]="item.isocode">
                                      {{item.name}}</option>
                                    }
                                  </select>
                                  <div class="invalid-feedback">
                                    @if ( reportECURecipientForm?.get('state')?.errors && reportECURecipientForm?.get('state')?.errors['required']) {
                                      <span class="text-danger-show"
                                        >
                                        <span>{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row margin-top-25">

                              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <label for="zip"
                                class="control-label">{{'reportECURecipientForm.zipPostalCode'|cxTranslate}}</label>
                                <input type="text" maxlength="15" formControlName="zip" class="form-control" name="zip"
                                  [ngClass]="{ 'is-valid': (reportECURecipientForm?.get('zip')?.dirty  ) && !reportECURecipientForm?.get('zip')?.errors, 'is-invalid': (reportECURecipientForm?.get('zip')?.dirty  ) && reportECURecipientForm?.get('zip')?.errors }">
                                  <div class="invalid-feedback">
                                    @if ( reportECURecipientForm?.get('zip')?.errors && reportECURecipientForm?.get('zip')?.errors['required']) {
                                      <span class="text-danger-show"
                                      >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                    }
                                  </div>

                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                  @if ((pageFieldData$|async); as pageFieldData) {
                                    <label for="country"
                                    class="control-label">{{'reportECURecipientForm.country'|cxTranslate}}</label>
                                    <div class="select-box">
                                      <select name="country" class="form-control" formControlName="country"
                                        (change)="onCountryChange($event)"
                                        [ngClass]="{ 'is-valid': (reportECURecipientForm?.get('country')?.dirty  ) && !reportECURecipientForm?.get('country')?.errors, 'is-invalid': (reportECURecipientForm?.get('country').dirty  ) && reportECURecipientForm?.get('country')?.errors }">
                                        <option [ngValue]="null" disabled selected>
                                        {{'common.form_register_empty'|cxTranslate}}</option>
                                        @for (item of pageFieldData['countriesWSList']; track item) {
                                          <option
                                            [ngValue]="item.isocode">
                                          {{item.name}}</option>
                                        }
                                      </select>
                                      <div class="invalid-feedback">
                                        @if ( reportECURecipientForm?.get('country')?.errors && reportECURecipientForm?.get('country')?.errors['required']) {
                                          <span class="text-danger-show"
                                          >{{'dataExtractionRquest.error_message'|cxTranslate}}</span>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>

                              <div class="row margin-top-25">
                                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><label for="zip"
                                class="control-label">{{'reportECURecipientForm.customer_reference_number'|cxTranslate}}</label>
                                <input type="text" formControlName="customerReferenceNumber" class="form-control"
                                  name="customerReferenceNumber">
                                </div>
                              </div>

                              <div class="endsure-btnblock">
                                <button class="btn-action btn-back mt-4" (click)="back()">
                                  <img src="/icons/link_left_white.svg" class="next-icon-right default-icon" alt="Back">
                                {{ 'dataExtractionRquest.back' | cxTranslate }}</button>

                                <button class="btn-action btn-next mt-4" [disabled]="!allowNext"
                                  (click)=" next()">{{'dataExtractionRquest.Next'|cxTranslate}}
                                  <img src="/icons/link-white.svg" class="next-icon-right default-icon" alt="Next">
                                </button>

                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Popup for customerName -->
                    @if (popupOpenCompanyName) {
                      <div class="popup-backdrop"></div>
                    }

                    @if (popupOpenCompanyName) {
                      <div class="popup-modal">
                        <div class="popup-header">
                          <button class="close-btn" aria-label="close dialog" (click)="closePopupCompanyName()">
                            <img src="/icons/close-light-grey.svg" alt="" />
                          </button>
                        </div>
                        <div class="popup-body">
                          <span class="popup-title">{{'reportECURecipientForm.company_name_popup_title'|cxTranslate}}</span>
                          <p class="mt-3">{{'reportECURecipientForm.company_name_popup_content'|cxTranslate}}</p>
                        </div>
                      </div>
                    }

                    <!-- Popup for contactName -->
                    @if (popupOpenContactName) {
                      <div class="popup-backdrop"></div>
                    }

                    @if (popupOpenContactName) {
                      <div class="popup-modal">
                        <div class="popup-header">
                          <button class="close-btn" aria-label="close dialog" (click)="closePopupContactName()">
                            <img src="/icons/close-light-grey.svg" alt="" />
                          </button>
                        </div>
                        <div class="popup-body">
                          <span class="popup-title">{{'reportECURecipientForm.contact_name_popup_title'|cxTranslate}}</span>
                          <p class="mt-3">{{'reportECURecipientForm.contact_name_popup_content'|cxTranslate}}</p>
                        </div>
                      </div>
                    }